import { type Object3D, Scene } from "three";

type SceneActivity = {
  revision: number;
  listeners: Set<() => void>;
};

const activities = new WeakMap<Scene, SceneActivity>();

function getActivity(scene: Scene): SceneActivity {
  let activity = activities.get(scene);
  if (!activity) {
    activity = { revision: 0, listeners: new Set() };
    activities.set(scene, activity);
  }
  return activity;
}

export function getSceneRevision(scene: Scene): number {
  return getActivity(scene).revision;
}

export function subscribeToSceneChanges(
  scene: Scene,
  listener: () => void,
): () => void {
  const activity = getActivity(scene);
  activity.listeners.add(listener);
  return () => {
    activity.listeners.delete(listener);
  };
}

/** Imperative geometry/transform changes must also wake demand-rendered scenes. */
export function markProductSceneChanged(object: Object3D): void {
  let root = object;
  while (root.parent) root = root.parent;
  // Detached objects have no viewer to update yet; their mount marks the scene.
  if (!(root instanceof Scene)) return;
  const activity = getActivity(root);
  activity.revision += 1;
  for (const listener of activity.listeners) listener();
}
